import config from "../../config";

export function getCloudinaryMediaUrl(
  imgKey: string,
  params: string = ""
): string {
  return config.cloudinaryApi
    .replace("{params}", params)
    .replace("{image}", imgKey);
}
